import * as React from "react";
import { RouteComponentProps, useNavigate } from "@reach/router";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import {
  Avatar,
  Box,
  Button,
  Link,
  Container,
  CssBaseline,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useUserSession } from "../lib/session";
import { Api } from "../lib/api";
import { Routes } from "../routes";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://authory.com/">
        authory.com
      </Link>{" "}
      {new Date().getFullYear()}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export const LoginPage: React.FC<RouteComponentProps> = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const { session, sessionToken, setSessionToken, setSession } =
    useUserSession();

  const [email, setEmail] = React.useState<string>("");
  const [password, setPassword] = React.useState<string>("");
  const [signinError, setSigninError] = React.useState<boolean>(false);

  if (session && session.isAdmin) {
    navigate(Routes.AllActiveUsers);
    return null;
  }

  const signin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await Api.login(email, password);
      const body = await response.data;

      if (body.user.isAdmin) {
        setSigninError(false);
        //@ts-ignore
        setSession(body.user);
        setSessionToken(body.authToken);
      } else {
        setSigninError(true);
      }
    } catch (err) {
      setSigninError(true);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Administrative Sign in
        </Typography>
        <form className={classes.form} noValidate onSubmit={signin}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign In
          </Button>
          {signinError && (
            <Typography component="p" variant="subtitle2" color="error">
              Error during login: Permission denied.
            </Typography>
          )}
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
};
